/**
 * Export configuration for each ERP screen.
 *
 * Each section describes a slice of the record data:
 *   key       - property name in the parent component's state object
 *   label     - human-readable name used as CSV section header / JSON key / XML tag
 *   type      - 'flat' for a single-record object, 'array' for tabular rows
 *   tabValue  - (optional) maps to the tab index for lazy-load awareness
 *   fields    - (optional) explicit field list with labels. When omitted,
 *               ALL keys from the API response data are exported dynamically
 *               with auto-humanized labels (e.g., FIRST_NAME -> "First Name").
 */

// ---------------------------------------------------------------------------
// Employee Export Config
// ---------------------------------------------------------------------------

export const employeeExportConfig = [
  {
    key: 'employee',
    label: 'Employee Main',
    type: 'flat',
    tabValue: 0,
  },
  {
    key: 'history',
    label: 'Pay Rate History',
    type: 'array',
    tabValue: 1,
  },
  {
    key: 'actions',
    label: 'Personnel Actions',
    type: 'array',
    tabValue: 2,
  },
  {
    key: 'reviews',
    label: 'Reviews',
    type: 'array',
    tabValue: 2,
  },
  {
    key: 'certificates',
    label: 'Certifications',
    type: 'array',
    tabValue: 2,
  },
  {
    key: 'disciplinaryActions',
    label: 'Disciplinary Actions',
    type: 'array',
    tabValue: 2,
  },
  {
    key: 'taxHeader',
    label: 'Tax Header',
    type: 'flat',
    tabValue: 3,
  },
  {
    key: 'taxDetail',
    label: 'Tax Detail',
    type: 'array',
    tabValue: 3,
  },
  {
    key: 'deductions',
    label: 'Deductions',
    type: 'array',
    tabValue: 4,
  },
  {
    key: 'years',
    label: 'Payroll Years',
    type: 'array',
    tabValue: 5,
  },
  {
    key: 'checks',
    label: 'Pay Stubs',
    type: 'array',
    tabValue: 6,
  },
  {
    key: 'fields',
    label: 'Field History',
    type: 'array',
    tabValue: 7,
  },
  {
    key: 'userFields',
    label: 'User Fields',
    type: 'array',
    tabValue: 8,
  },
  {
    key: 'benefits',
    label: 'Benefits',
    type: 'array',
    tabValue: 9,
  },
  {
    key: 'dependents',
    label: 'Dependents',
    type: 'array',
    tabValue: 11,
  },
  {
    key: 'dependentBenefits',
    label: 'Dependent Benefits',
    type: 'array',
    tabValue: 11,
  },
  {
    key: 'positionHistory',
    label: 'Position History',
    type: 'array',
    tabValue: 12,
  },
]

// ---------------------------------------------------------------------------
// Vendor Export Config
// ---------------------------------------------------------------------------

export const vendorExportConfig = [
  {
    key: 'vendorData',
    label: 'Vendor Main',
    type: 'flat',
    tabValue: 0,
  },
  {
    key: 'locations',
    label: 'Locations',
    type: 'array',
    tabValue: 2,
  },
  // Note: Invoices and POs use server-side paginated tables and are excluded
  // from v1 export. A backend download endpoint would be needed for full export.
]
